import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Card3D — herbruikbare tegel-container met 3D-look.
 * Gebruikt door Orders Decoprof tabel-container; consistent met dashboard tegels.
 */
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card3D = React.forwardRef<HTMLDivElement, Props>(
  ({ children, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "relative rounded-2xl border border-slate-200/70 bg-card text-card-foreground",
        "shadow-[0_8px_20px_-6px_rgba(15,23,42,0.18),0_2px_6px_rgba(15,23,42,0.08),inset_0_1px_0_rgba(255,255,255,0.85)]",
        "transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_28px_-8px_rgba(15,23,42,0.22),0_4px_10px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.9)]",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);
Card3D.displayName = "Card3D";

export default Card3D;
